import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { API_LINK } from '../../apiLink/apiLink';

const LibraryRequests = ({ onNavigate }) => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_LINK}/api/library/requests`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const result = await response.json();

            if (result.success) {
                setRequests(result.data.requests || []);
            } else {
                setError(result.message || 'Failed to fetch requests');
            }
        } catch (err) {
            console.error('Error fetching requests:', err);
            setError('An error occurred while fetching requests');
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateStatus = async (id, status) => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_LINK}/api/library/requests/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ status })
            });

            const result = await response.json();
            if (result.success) {
                // Refresh list
                fetchRequests();
            } else {
                alert(result.message || `Failed to ${status} request`);
            }
        } catch (error) {
            console.error(`Error updating request to ${status}:`, error);
            alert(`An error occurred while updating the request.`);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return isNaN(date.getTime()) ? '' : date.toISOString().split('T')[0];
    };

    return (
        <Layout role="librarian" onNavigate={onNavigate} activePage="library-requests" pageTitle="Book Requests">
            <div style={{ padding: '20px' }}>
                <h2 style={{ color: '#333', marginBottom: '2rem' }}>📋 Book Requests</h2>

                {error && (
                    <div style={{ backgroundColor: '#ffeef0', color: '#e53935', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #ffccd5' }}>
                        <strong>❌ Error:</strong> {error}
                    </div>
                )}

                <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', padding: '20px' }}>
                    <div style={{ overflowX: 'auto' }}>
                        {loading ? (
                            <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>Loading requests...</div>
                        ) : (
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ borderBottom: '2px solid #eee', textAlign: 'left' }}>
                                        <th style={{ padding: '15px' }}>Request ID</th>
                                        <th style={{ padding: '15px' }}>Book Title</th>
                                        <th style={{ padding: '15px' }}>Requested By</th>
                                        <th style={{ padding: '15px' }}>Date</th>
                                        <th style={{ padding: '15px' }}>Status</th>
                                        <th style={{ padding: '15px' }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {requests.length > 0 ? (
                                        requests.map(req => (
                                            <tr key={req.id} style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '15px' }}>#{req.id}</td>
                                                <td style={{ padding: '15px', fontWeight: '500' }}>{req.book_title}</td>
                                                <td style={{ padding: '15px' }}>{req.member_name}</td>
                                                <td style={{ padding: '15px' }}>{formatDate(req.request_date || req.created_at)}</td>
                                                <td style={{ padding: '15px' }}>
                                                    <span style={{
                                                        backgroundColor: req.status === 'pending' ? '#fff3e0' : (req.status === 'approved' ? '#e3f2fd' : (req.status === 'rejected' ? '#ffebee' : '#e8f5e9')),
                                                        color: req.status === 'pending' ? '#ef6c00' : (req.status === 'approved' ? '#1976d2' : (req.status === 'rejected' ? '#c62828' : '#2e7d32')),
                                                        padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', textTransform: 'capitalize'
                                                    }}>
                                                        {req.status}
                                                    </span>
                                                </td>
                                                <td style={{ padding: '15px', display: 'flex', gap: '8px' }}>
                                                    {req.status === 'pending' && (
                                                        <>
                                                            <button
                                                                onClick={() => handleUpdateStatus(req.id, 'approved')}
                                                                style={{ backgroundColor: '#238548', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
                                                            >
                                                                Approve
                                                            </button>
                                                            <button
                                                                onClick={() => handleUpdateStatus(req.id, 'rejected')}
                                                                style={{ backgroundColor: '#f44336', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
                                                            >
                                                                Reject
                                                            </button>
                                                        </>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>No book requests found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default LibraryRequests;
